
<template>
    <div class="center examplex permisos">
        <div class="encabezado">
            <h6 class="mb-0">Usuarios</h6>
        </div>
        <p class="sinInfo" v-if="!users[0]">Sin información</p>
        <details 
            :key="i"
            v-for="(tr, i) in users"
            class="divisionLineas"
            v-else
        >
            <summary>
				<span><i class="fas fa-caret-down"></i></span>
                <div>
                    <h6>
                        <strong>{{tr.name}}</strong>
                    </h6>
                    <small>Correo: </small>
                    <span><strong>{{tr.email}}</strong></span>
                </div>
            </summary>
            
            <vs-table>
                <template #thead>
                <vs-tr>
                    <vs-th style="width: 70%">
                        <span>Institutos vinculados</span>
                    </vs-th>
                    <vs-th style="width: 20%">
                        <span>Rol</span>
                    </vs-th>
                    <vs-th style="width: 10%">
                        <span>Acción</span>
                    </vs-th>
                </vs-tr>
                </template>
                <template #tbody>
                    <vs-tr
                        style="vertical-align: initial"
                    >
                        <vs-td>
                            <vs-row>
                                <vs-col w="6" v-for="(cole, j) in tr.instituciones" :key="j" class="p-2 divisionLineasTop">
                                    <i class="fas fa-school mr-1"></i>{{ cole.institucion.nombre }}
                                </vs-col>
                            </vs-row>
                        </vs-td>
                        <vs-td>
                            <vs-row>
                                <vs-col w="12" v-for="(cole, j) in tr.roles" :key="j" class="p-2">
                                    <i class="fas fa-user mr-1"></i>{{ cole.name }}
                                </vs-col>
                            </vs-row>
                        </vs-td>
                        <vs-td>
                            <vs-button
                                flat
                                class="ml-auto"
                                @click="activeModificar =! activeModificar, selectRow = tr"
                            >
                                <i class="fas fa-edit mr-2"></i>Editar
                            </vs-button>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </details>
        <vs-pagination class="mt-2" v-model="pagina" :length="pages" />     
        <editar v-model="activeModificar" :row="selectRow" :instituciones="instituciones" :institucionId="institucionId" @refreshTable="refreshInfo"></editar>
    </div>
</template>
<script>
import editar from './modal/editar.vue'
export default {
    props:[
        'users',
        'instituciones',
        'institucionId',
        'page',
        'pages'
    ],
    components:{
        editar
    },
    data:() => ({
        activeModificar: false,
        selectRow: [],
        pagina: 1
    }),
    methods:{
        refreshInfo(){
            this.$emit('refreshTable')
        }
    },
    watch: {
        // page(){
        //     this.pagina = this.page
        // },
        pagina(){
            this.$emit('getPage',this.pagina)
            console.log(this.pagina)
        }
    }
}
</script>
<style>

.divisionLineas:not(:last-child){
    border-bottom: 1px solid #cccccc; 
}
.divisionLineasTop:not(:first-child):not(:nth-of-type(2)){
    border-top: 1px solid #e7e7e7; 
}
</style>

<style lang="scss" scoped>
summary {
	background-color: #fff;
	position: relative;
	cursor: pointer;
	padding: 1em .5em;
    display: flex;
    align-items: center;
	list-style: none; // Remove arrow
	&::-webkit-details-marker {
		display: none; // Remove arrow
	}
	
	&:hover {
		background-color: #f2f5f9;
        border-radius: 7px;
	}
	
	h5 {
		display: flex;
		flex-direction: column;
	}
	small {
		color: #999;
		font-size: .875em;
	}
	
	strong {
		font-weight: 700;
	}
	
	span:first-child {
		width: 2rem;
		height: 4rem;
		display: flex;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		margin-right: 0.9em;
	}
	
	&:focus {
		outline: none;
	}
	
	.plus {
		color: #289672;
	}
}

</style>
<style scoped>
.permisos details, .tableModulo{
    width: 100%;
}
.tableModulo tr th{
    background: #efefef;
    padding: 6px 10px;
}
.tableModulo tr th span{
    font-size: 12px;
}
.tableModulo tr td{
    font-size: 12px;
}
.alinearTexto{
    padding: 6px 10px;
    background: #fdfdfd !important;
}
.alinearTexto p{
    margin:0 !important;
}
.divisionLineasPadres:not(:last-child){
    border-bottom: 2px solid #ececec;
}
</style>
<style lang="scss" scoped>
.permisos{
    .encabezado{
        border-radius: 14px 14px 0 0;
        background: #F4F7F8;
        padding: 10px 12px;
    }
    .sinInfo{
        padding: 20px;
        text-align: center;
    }
    details{
        padding: 10px 12px;
    }
    details:not(:last-child){
        border-bottom: 2px solid #ececec;
    }
    details summary{
    font-size: 15px;
    }
}
</style>
<style>
.permisos div.vs-table-content > div.vs-table > table{
        margin: 0 auto !important;
        width: 98% !important;
}
</style>

        